export const appConfig = {
    baseUrl: "https://www.lagunacreek.io/blog/wp-json/custom/v1"
}